import '../stylesheets/main.scss';
import '../javascripts/my';
import my from '../javascripts/my';
my();
